<ngx-file-drop
    (onFileDrop)="dropped($event)"
    multiple="false"
    contentClassName="d-flex flex-column justify-content-center align-items-center"
    [accept]="acceptedFileType"
>
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div class="theme-new w-100">
            <ng-container *ngIf="validating$ | async; else uploadBtn">
                <button class="btn btn-disabled btn-click-here text-wrap p-1 w-100" translate buttonDataTest="uploadSubtitlesDisabledButton">
                    v3-subtitles-uploader-click-here-btn
                </button>
            </ng-container>
            <ng-template #uploadBtn>
                <button
                    class="btn btn-secondary btn-click-here text-wrap p-1 w-100"
                    (enterKeyUp)="openFileSelector()"
                    (spaceKeyUp)="openFileSelector()"
                    (click)="openFileSelector()"
                    translate
                    buttonDataTest="uploadSubtitlesButton"
                >
                    v3-subtitles-uploader-click-here-btn
                </button>
            </ng-template>
        </div>
    </ng-template>
</ngx-file-drop>
